import React from 'react'
import { Helmet } from 'react-helmet-async'

interface Props {
  items: Array<App.QuestionAndAnswer>
}

function FaqStructuredData(props: Props) {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: props.items.map(item => ({
            '@type': 'Question',
            name: item.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: item.answer,
            },
          })),
        })}
      </script>
    </Helmet>
  )
}

export default React.memo(FaqStructuredData)
